import React, { useState } from 'react';
import './LoginPage.css';
import Box from '@mui/material/Box';
import { baseUrl, getOptions, setAuthToken } from '../../../auth/authUtil';
import axios from 'axios';
import handleErrors from '../../../assets/apiEroor/ErrorHandler';
import { Navigate, useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import logo from '../../../logo.png';
import UserNameIcon from '../../../assets/images/icons/username.svg';
import PasswordIcon from '../../../assets/images/icons/password.svg';
import AccountTypeIcon from '../../../assets/images/icons/account-type.svg';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Link } from 'react-router-dom';

export default function ResetPasswordPage() {
   const [username, setUsername] = useState('admin');
   const [errorMessage, setErrorMessage] = useState('');
   const [selectAccountType, setAccountType] = useState('admin');

   const accountType = [
      { name: 'Publisher' },
      { name: 'Supply' },
      { name: 'Demand' },
      { name: 'Intermediary' },
   ];

   const handleResetPassword = () => {
      // Make a request to your backend API to initiate password reset
      axios.post('/api/account/reset-password/init', { username, accountType: selectAccountType })
         .then(response => {
            // Handle success
            alert('Password reset email sent successfully!');
         })
         .catch(error => {
            // Handle error
            console.error('Error sending reset password email:', error);
            setErrorMessage('Failed to send reset password email. Please try again.');
         });
   };

   return (
      <div className="login-container">
         <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }} className="logo-wrapper">
            <img src={logo} className='brand-logo' alt="logo" />
            {/* <Typography level="title-lg" className='brand-name'>Omega</Typography> */}
         </Box>
         {errorMessage && <p className="error-message">{errorMessage}</p>}
         <label className='fs-12-600'>Username</label>
         <div className="p-inputgroup flex-1">
            <span className="p-inputgroup-addon">
               <img src={UserNameIcon} alt="Username Icon" />
            </span>
            <span className='divider'></span>
            <InputText placeholder="bpandey@adelement.com" onChange={(e) => setUsername(e.target.value)} />
         </div>
         <label className='fs-12-600'>Account Type</label>
         <div className="p-inputgroup flex-1">
            <span className="p-inputgroup-addon">
               <img src={AccountTypeIcon} alt="AccountType Icon" />
            </span>
            <span className='divider'></span>
            <Dropdown placeholder='Publisher' value={selectAccountType} onChange={(e) => setAccountType(e.value)} options={accountType} optionLabel="name" className="auto-width h-30" />
         </div>
         <button className="login-button" onClick={handleResetPassword}>
            Reset My Password 
         </button>
         <Link to="/login" className='forgot-password-button'>Already  a User ? Login here</Link>
      </div>
   );
};


